export default __webpack_public_path__ + "static/media/travel.dfeeeb66.svg";